// extracted by mini-css-extract-plugin
export var card = "_k1-5";
export var cardSelected = "_k1-4";
export var image = "_k1-3";
export var modal = "_k1-0";
export var modalContent = "_k1-1";
export var table = "_k1-2";